<div class="bundling-settings-tabs-wrapper" [ngStyle]="state.columnGrid">
  @for (tab of tabs; track tab) {
    <button class="bundling-settings-tabs-button"
      [attr.data-cy]="getTabDynamicDataCy(tab.tabCode)"
      [ngClass]="{'active': isTabActive(tab.tabCode)}"
      (click)="clickTab(tab.tabCode)">
      <app-tooltip message="{{tab.tabName}}" [dynamic]="true">
        <span>{{tab.tabName}}</span>
      </app-tooltip>
    </button>
  }
</div>
